export class Cart {
    items = {};
    varient = [];
    payMode = 0;
}
